module.exports = __webpack_public_path__ + "fb0a1047f2d530f4c128dc26b2412863.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Dr-haiel3.png
// module id = 55
// module chunks = 0